import { useState } from 'react';
import {
  Carousel,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  CarouselContent,
  CarouselItem,
} from '@tameeni/ui';
import { ProductItem, ProductsList } from '@tameeni/home';
import { useTranslation } from 'react-i18next';
import { useHomeLinks } from '@Components/Layout/hooks/useHomeLinks';
import { Products } from '@tameeni/shared-logic';

const TameeniProductsList = () => {
  const [selectedTab, setSelectedTab] = useState<string>('individuals');
  const { t } = useTranslation(['home']);
  const { SME_PRODUCTS, INDIVIDUAL_PRODUCTS, HOME_LINKS } = useHomeLinks();

  const changeActiveTab = (activeTab: string) => () => {
    setSelectedTab(activeTab);
  };

  return (
    <ProductsList
      title={t('home:tameeni_products.title')}
      subtitle={t('home:tameeni_products.subtitle')}
    >
      <Tabs locale='en' value={selectedTab} onValueChange={setSelectedTab} variant='enclosed'>
        <TabsList className='mb-8 min-w-[15.5625rem]' isCentered>
          <TabsTrigger
            value='individuals'
            className='grow'
            onClick={changeActiveTab('individuals')}
          >
            {t('home:megaMenu.forIndividual')}
          </TabsTrigger>

          <TabsTrigger value='corporate' className='grow' onClick={changeActiveTab('corporate')}>
            {t('home:megaMenu.forBusiness')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value='individuals'>
          <Carousel className='center' opts={{ dragFree: true, align: 'start' }}>
            <CarouselContent>
              {INDIVIDUAL_PRODUCTS.map((product, idx) => (
                <CarouselItem key={idx} className='w-full max-w-72'>
                  <a href={HOME_LINKS[product]}>
                    <ProductItem
                      idx={idx}
                      title={t(
                        `products:${Object.keys(Products).find((key) => {
                          return Products[key as keyof typeof Products] === product;
                        })}`,
                      )}
                      //   description={t(`products:${product}_description`)}
                      btnLabel={t('home:home_hero.get_quote')}
                      image={`/Resources/images/home/products/${product}.png`}
                    />
                  </a>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </TabsContent>

        <TabsContent value='corporate'>
          <Carousel className='center' opts={{ dragFree: true, align: 'start' }}>
            <CarouselContent>
              {SME_PRODUCTS.map((product, idx) => (
                <CarouselItem key={idx} className='w-full max-w-72'>
                  <a href={HOME_LINKS[product]}>
                    <ProductItem
                      idx={idx}
                      title={t(
                        `products:${Object.keys(Products).find((key) => {
                          return Products[key as keyof typeof Products] === product;
                        })}`,
                      )}
                      //   description={t(`products:${product}_description`)}
                      btnLabel={t('home:home_hero.get_quote')}
                      image={`/Resources/images/home/products/${product}.png`}
                    />
                  </a>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </TabsContent>
      </Tabs>
    </ProductsList>
  );
};

export default TameeniProductsList;
